import { createFileRoute } from '@tanstack/react-router';
import { SignInOtp } from '@/pages';

export const Route = createFileRoute('/_public/signin/otp')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: SignInOtp,
});
